
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M22 2v8H10v12H2V2h20zM8 10v10H4V10h4zM4 8h16V4H4v4z","fill":"#2A333D"}}),_c('path',{attrs:{"d":"M20 12h-2v3.5a2.5 2.5 0 01-2.5 2.5v-2.5L12 20h3.7a4.3 4.3 0 004.3-4.3V12z","fill":"#2A333D"}})])
          )
        }
      }
    